<template>
  <MainLayout>
    <!-- Header -->
    <PageHeader 
      icon="ri-file-list-3-line"
      title="Registro Académico"
      :subtitle="cursoActualNombre"
      button-text="Actualizar"
      button-icon="ri-loop-right-line"
      @action="actualizar"
    />

    <div class="content-container">
      <div v-if="registro">
        <!-- Resumen Compacto -->
        <div v-if="resumen && registro.length > 0" class="summary-bar">
          <div class="summary-item">
            <i class="ri-checkbox-circle-line"></i>
            <span class="summary-label">Asistencias:</span>
            <strong class="summary-value success">{{ resumen.clases }}</strong>
            <span class="summary-percent">({{ Math.round((resumen.clases / resumen.total) * 100) }}%)</span>
          </div>
          <div class="summary-divider"></div>
          <div class="summary-item">
            <i class="ri-close-circle-line"></i>
            <span class="summary-label">Ausencias:</span>
            <strong class="summary-value danger">{{ resumen.inasistencias }}</strong>
            <span class="summary-percent">({{ Math.round((resumen.inasistencias / resumen.total) * 100) }}%)</span>
          </div>
          <div class="summary-divider"></div>
          <div class="summary-item">
            <i class="ri-clipboard-line"></i>
            <span class="summary-label">Total:</span>
            <strong class="summary-value">{{ resumen.total }}</strong>
          </div>
        </div>

        <!-- Nota Informativa -->
        <div v-if="registro.length > 0" class="info-note">
          <i class="ri-information-line"></i>
          <span>Los ítems resaltados con fondo azul corresponden a clases evaluativas</span>
        </div>

        <!-- Lista Compacta de Registros -->
        <div v-if="registro.length > 0" class="records-list">
          <div class="list-header">
            <span class="col-id">#</span>
            <span class="col-tema">Tema</span>
            <span class="col-info">Docente, Sede y Fecha</span>
            <span class="col-estado">Estado</span>
            <span class="col-asiste">Asiste</span>
            <span class="col-nota">Nota</span>
          </div>

          <div v-for="(fila, index) in registro" :key="index" class="list-item" :class="{ 'evaluative': fila.rango_nota !== null }">
            <span class="col-id">
              {{ index + 1 }}
            </span>
            
            <span class="col-tema">
              <i v-if="fila.rango_nota !== null" class="ri-file-edit-line eval-indicator" title="Clase evaluativa"></i>
              <span class="tema-text">
                {{ fila.nombre }}
              </span>
            </span>
            
            <span class="col-info">
              <div class="info-content">
                <span class="info-docente">
                  <i class="ri-user-2-line"></i>
                  {{ docent(fila.progreso) || '—' }}
                </span>
                <span class="info-ubicacion">
                  <i class="ri-map-pin-line"></i>
                  {{ fila.progreso && fila.progreso.salon ? ubicacion(fila.progreso.salon, fila.progreso.clase_fecha) : '—' }}
                </span>
              </div>
            </span>
            
            <span class="col-estado">
              <span v-if="fila.progreso && fila.progreso.estado == 'superado'" class="badge" :class="getClassEstado(fila)">
                <a 
                  href="https://americanschoolway.edu.co/solicitudes-academicas/" 
                  v-if="fila.progreso.asistencia == 0"
                  title="Solicitar supletorio"
                  target="_blank"
                  rel="noopener noreferrer">
                  Visto
                </a>
                <span v-else>Visto</span>
              </span>
              <span v-else class="badge badge-warning">Pendiente</span>
            </span>
            
            <span class="col-asiste">
              <span v-if="fila.progreso && fila.progreso.asistencia !== null" 
                    :class="fila.progreso.asistencia ? 'badge-mini success' : 'badge-mini danger'">
                {{ fila.progreso.asistencia ? "SÍ" : "NO" }}
              </span>
              <span v-else class="text-muted">—</span>
            </span>
            
            <span v-if="fila.rango_nota !== null" class="col-nota">
              <span v-if="fila.progreso && fila.progreso.nota" class="nota-badge">{{ fila.progreso.nota }}</span>
              <span v-else class="text-muted">—</span>
            </span>
          </div>
        </div>

        <!-- Estado Vacío -->
        <div v-else class="empty-state">
          <i class="ri-file-text-line" style="font-size: 4rem; opacity: 0.3;"></i>
          <h3>No hay registros aún</h3>
          <p>Tus clases aparecerán aquí una vez que completes tu primera sesión.</p>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import utils from '@/modules/utils';
import MainLayout from './Layout/MainLayout.vue';
import PageHeader from './Layout/PageHeader.vue';


export default {
  name: 'RegistroAcademico',
  components: {
    MainLayout,
    PageHeader
  },
  data() {
    return {

    }
  },
  mounted() {
    if (!this.cursoActual) {
      this.fetchCursoActual()
    }
    if (!this.registro || (this.registro && this.registro.length == 0)) {
      this.actualizar()
    }

  },
  methods: {
    ...mapActions({
      fetchRegistroAcademicoActual: 'academico/fetchRegistroAcademicoActual',
      fetchCursoActual: 'academico/fetchCursoActual',
    }),
    ...mapMutations({

    }),
    getClassEstado(fila){
      if (fila.progreso && fila.progreso.estado == 'superado' && fila.progreso.asistencia) {
        return 'badge-success';
      }
      return 'badge-pending';
    },
    actualizar() {
      this.fetchCursoActual()
      this.fetchRegistroAcademicoActual()
    },
    ubicacion(salon, fecha) {
      var fec = ""
      var ho = "";
      var sede = ""
      if (fecha != null && fecha != "") {
        fecha = this.$moment(fecha).format('DD/MM/YYYY HH:mm:ss');
      } else { fecha = "" }
      if (salon != null)
        sede = JSON.parse(salon).sede
      else
        sede = ""
      return sede + " " + fecha;
    },
    docent(progreso) {
      if (progreso && progreso.docente) {
        if (progreso.docente != null) {
          var docente = JSON.parse(progreso.docente)
          return docente.nombre
        } else { return ""; }
      }
      else { return ""; }
    },

  },
  computed: {
    ...mapState({
      registro: state => state.academico.registro_academico_actual,
      resumen: state => state.academico.registro_academico_resumen,
      cursoActual: state => state.academico.cursoActual,
    }),
    ...mapGetters({

    }),
    cursoActualNombre() {
      if (this.cursoActual) {
        return this.cursoActual.nombre
      }
      return ''
    }
  }
}
</script>

<style scoped>
.registro-academico-modern {
  min-height: 100vh;
  background: var(--theme-gradient-bg);
  font-family: var(--app-font-family);
}

/* ============================================
   RESUMEN COMPACTO
   ============================================ */
.summary-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: var(--theme-shadow-sm);
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}

.summary-item svg {
  color: var(--app-primary-blue);
  flex-shrink: 0;
}

.summary-label {
  color: var(--theme-text-secondary);
  font-weight: 500;
}

.summary-value {
  color: var(--theme-text-primary);
  font-weight: 700;
  font-size: 1.125rem;
}

.summary-value.success {
  color: #10b981;
}

.summary-value.danger {
  color: #ef4444;
}

.summary-percent {
  color: var(--theme-text-muted);
  font-size: 0.8125rem;
}

.summary-divider {
  width: 1px;
  height: 24px;
  background: var(--theme-border-color);
}

/* ============================================
   NOTA INFORMATIVA
   ============================================ */
.info-note {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  background: linear-gradient(90deg, rgba(13, 78, 140, 0.08) 0%, transparent 100%);
  border-left: 3px solid rgba(13, 78, 140, 0.4);
  border-radius: 6px;
  font-size: 0.8125rem;
  color: var(--theme-text-secondary);
  font-style: italic;
}

.info-note i {
  color: var(--app-primary-blue);
  font-size: 1rem;
  flex-shrink: 0;
}

html.light-theme .info-note,
.light-theme .info-note {
  background: linear-gradient(90deg, rgba(13, 78, 140, 0.12) 0%, transparent 100%);
  border-left-color: rgba(13, 78, 140, 0.5);
}

/* ============================================
   LISTA COMPACTA DE REGISTROS
   ============================================ */
.records-list {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--theme-shadow-md);
}

.list-header {
  display: grid;
  grid-template-columns: 50px 2fr 2.5fr 120px 80px 80px;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  background: var(--theme-bg-secondary);
  border-bottom: 2px solid var(--theme-border-color);
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.list-item {
  display: grid;
  grid-template-columns: 50px 2fr 2.5fr 120px 80px 80px;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid var(--theme-border-color);
  transition: background-color 0.15s ease;
  align-items: center;
  font-size: 0.875rem;
}

.list-item:last-child {
  border-bottom: none;
}

.list-item:hover {
  background: var(--theme-hover-bg);
}

.list-item.evaluative {
  background: linear-gradient(135deg,
      rgba(13, 78, 140, 0.1) 0%,
      rgba(79, 172, 254, 0.3) 50%,
      rgba(13, 78, 140, 0.1) 100%);
  border-left: 3px solid rgba(13, 78, 140, 0.5);
  padding-left: calc(1rem - 3px);
}

.col-id {
  color: var(--theme-text-muted);
  font-weight: 600;
  text-align: center;
  position: relative;
}

.eval-indicator {
  font-size: 0.75rem;
  color: var(--theme-text-primary);
  opacity: 0.85;
  transition: all 0.3s ease;
  font-weight: bold;
}

.col-tema,
.col-info {
  color: var(--theme-text-primary);
}

.col-tema {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tema-text {
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-docente {
  color: var(--theme-text-primary);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.3;
}

.info-ubicacion {
  color: var(--theme-text-secondary);
  font-size: 0.75rem;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-docente, .info-ubicacion {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.col-estado,
.col-asiste,
.col-nota {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Badges */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.badge-success {
  background: var(--theme-gradient-secondary);
  color: white;
  box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
}

.badge-warning {
  background: var(--app-primary-red);
  color: white;
}

.badge-pending {
  background: var(--theme-bg-tertiary);
  color: var(--theme-text-secondary);
  border: 1px solid var(--theme-border-color);
}

.badge a {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.badge a:hover {
  text-decoration: underline;
  opacity: 0.9;
}

.badge a::after {
  content: '🔗';
  font-size: 0.65rem;
  transition: opacity 0.3s ease;
}

.badge-mini {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 700;
  text-align: center;
  min-width: 40px;
}

.badge-mini.success {
  background: var(--theme-gradient-secondary);
  color: white;
}

.badge-mini.danger {
  background: #ef4444;
  color: white;
}

.nota-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  padding: 0.375rem 0.625rem;
  background: var(--theme-gradient-primary);
  color: white;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(13, 78, 140, 0.25);
}

.text-muted {
  color: var(--theme-text-muted);
  font-size: 0.875rem;
}

/* ============================================
   ESTADO VACÍO
   ============================================ */
.empty-state {
  background: var(--theme-bg-card);
  border: 2px dashed var(--theme-border-color);
  border-radius: 12px;
  padding: 3rem 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.empty-state svg {
  color: var(--theme-text-tertiary);
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
}

.empty-state p {
  font-size: 0.9375rem;
  color: var(--theme-text-secondary);
  max-width: 400px;
  margin: 0;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */
@media (max-width: 1024px) {
  .list-header,
  .list-item {
    grid-template-columns: 40px 1.5fr 1.8fr 100px 70px 70px;
    gap: 0.5rem;
    padding: 0.75rem 0.875rem;
    font-size: 0.8125rem;
  }

  .list-header {
    font-size: 0.75rem;
  }
}

@media (max-width: 768px) {
  .content-container {
    padding: 1rem;
  }

  .summary-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 1rem;
  }

  .summary-item {
    justify-content: space-between;
    padding: 0.5rem;
    background: var(--theme-bg-tertiary);
    border-radius: 6px;
  }

  .summary-divider {
    display: none;
  }

  /* Lista modo móvil: tarjetas compactas */
  .list-header {
    display: none;
  }

  .records-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .list-item {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    padding: 0.875rem;
    background: var(--theme-bg-card);
    border: 1px solid var(--theme-border-color);
    border-radius: 8px;
    box-shadow: var(--theme-shadow-sm);
  }

  .list-item.evaluative {
    border-left: 4px solid rgba(13, 78, 140, 0.6);
    padding-left: calc(0.875rem - 3px);
  }

  .col-id {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: var(--theme-bg-tertiary);
    border-radius: 6px;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--theme-text-muted);
    flex-shrink: 0;
    order: 1;
  }

  /* Fila 1: Tema sin icono */
  .col-tema {
    flex: 1;
    font-size: 0.9375rem;
    display: flex;
    align-items: center;
    order: 1;
  }

  /* Fila 2: Info (Docente y Ubicación) */
  .col-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    order: 2;
  }

  .info-content {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
    width: 100%;
  }

  .info-docente {
    white-space: normal;
  }

  .info-ubicacion {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  }

  /* Divisor visual */
  .col-info::after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    background: var(--theme-border-color);
    margin-top: 0.25rem;
  }

  /* Fila 3: Estado, Asiste y Nota con labels */
  .col-estado {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    order: 3;
    flex: 1 1 auto;
  }

  .col-estado::before {
    content: "Estado";
    font-size: 0.6875rem;
    color: var(--theme-text-muted);
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.025em;
  }

  .col-asiste {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    order: 3;
    flex: 0 0 auto;
  }

  .col-asiste::before {
    content: "Asiste";
    font-size: 0.6875rem;
    color: var(--theme-text-muted);
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.025em;
  }

  .col-nota {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    order: 3;
    flex: 0 0 auto;
  }

  .col-nota::before {
    content: "Nota";
    font-size: 0.6875rem;
    color: var(--theme-text-muted);
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.025em;
  }

  /* Asegurar que la tercera fila ocupe el 100% y tenga space-between */
  .list-item > .col-estado,
  .list-item > .col-asiste,
  .list-item > .col-nota {
    width: auto;
  }

  .list-item > .col-estado {
    margin-right: auto;
  }
}

@media (max-width: 480px) {
  .summary-value {
    font-size: 1rem;
  }
}
</style>